import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../state/auth';

export function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export function RequireAdmin({ children }) {
  const { user, loading, isAdmin } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (!isAdmin) return <Navigate to="/" replace />;
  return children;
}

// Admin OR editor. Guards the shared admin-area pages (dashboard, orders, story
// builder/editor). Admin-only pages (stats, templates, users, settings) keep
// RequireAdmin so editors are bounced to the home page.
export function RequireStaff({ children }) {
  const { user, loading, isStaff } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (!isStaff) return <Navigate to="/" replace />;
  return children;
}
